import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
export var updateCommentBadges = createAction("".concat(actionTypePrefix, "/UPDATE_COMMENT_BADGES"), function (comment, allBadges) { return ({
    comment: comment,
    allBadges: allBadges,
}); });
export var likeComment = createAction("".concat(actionTypePrefix, "/LIKE"), function (comment) { return ({
    comment: comment,
}); });
export var unlikeComment = createAction("".concat(actionTypePrefix, "/UNLIKE"), function (comment) { return ({
    comment: comment,
}); });
export var toggleReactionToComment = createAction("".concat(actionTypePrefix, "/TOGGLE_REACTION"), function (comment, reaction) { return ({
    comment: comment,
    reaction: reaction,
}); });
export var setCommentReactions = createAction("".concat(actionTypePrefix, "/SET_REACTIONS"), function (allReactions) { return ({ allReactions: allReactions }); });
export var saveCommentReactionsToLocalStorage = createAction("".concat(actionTypePrefix, "/SAVE_REACTIONS"), function (comment, reactions) { return ({
    comment: comment,
    reactions: reactions,
}); });
export var reportComment = createAction("".concat(actionTypePrefix, "/REPORT"), function (comment) { return ({
    comment: comment,
}); });
export var featureComment = createAction("".concat(actionTypePrefix, "/FEATURE"), function (comment) { return ({
    comment: comment,
}); });
export var unfeatureComment = createAction("".concat(actionTypePrefix, "/UNFEATURE"), function (comment) { return ({
    comment: comment,
}); });
export var hideComment = createAction("".concat(actionTypePrefix, "/HIDE"), function (comment, insideModal) { return ({
    comment: comment,
    insideModal: insideModal,
}); });
export var unhideComment = createAction("".concat(actionTypePrefix, "/UNHIDE"), function (comment) { return ({
    comment: comment,
}); });
export var requestSuccess = createAction("".concat(actionTypePrefix, "/SUCCESS"), function (actionType, comment) { return ({
    isBusy: false,
    comment: comment,
    actionType: actionType,
}); });
export var requestFailure = createAction("".concat(actionTypePrefix, "/FAILURE"), function (actionType, comment, error) { return ({
    comment: comment,
    error: error,
    actionType: actionType,
}); });
export var reduxModuleLoaded = createAction("".concat(actionTypePrefix, "/REDUX_MODULE_LOADED"), function () { return ({}); });
//# sourceMappingURL=actionCreators.js.map